module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "docs-demo-wrapper"
  }, [_c('div', {
    staticClass: "demo-container",
    style: ({
      maxHeight: _vm.isExpand ? '700px' : '0'
    })
  }, [_c('div', {
    attrs: {
      "span": "14"
    }
  }, [_c('div', {
    staticClass: "docs-demo docs-demo--expand"
  }, [_c('div', {
    staticClass: "highlight-wrapper"
  }, [_vm._t("highlight")], 2)])])]), _vm._v(" "), _c('span', {
    staticClass: "docs-trans docs-demo__triangle",
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v(_vm._s(_vm.isExpand ? '隐藏代码' : '显示代码'))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-b1a15296"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./client/components/demo-block.vue
// module id = 277
// module chunks = 3